import { memo } from "react";
import { MonthEndActivityLogTablePanel } from "./MonthEndActivityLogTablePanel";

const MonthEndActivityLogContent: React.FC = () => {
    return <div className={`main-comp-wrapper`} style={{ width: "60vw", height: "69vh" }}>
        <MonthEndActivityLogTablePanel />
    </div>
}

export default memo(MonthEndActivityLogContent);